import { render } from "./GIS.vue?vue&type=template&id=ae5ab57a&scoped=true"
import script from "./GIS.vue?vue&type=script&lang=js"
export * from "./GIS.vue?vue&type=script&lang=js"

import "./GIS.vue?vue&type=style&index=0&id=ae5ab57a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae5ab57a"],['__file',"src/views/pharmarcy/GIS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ae5ab57a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ae5ab57a', __exports__)) {
    api.reload('ae5ab57a', __exports__)
  }
  
  module.hot.accept("./GIS.vue?vue&type=template&id=ae5ab57a&scoped=true", () => {
    api.rerender('ae5ab57a', render)
  })

}


export default __exports__